(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popular-departments"] && !Shopify.designMode) return;
  try {
    
  /**
   * Popular Departments slider.
   * Single Swiper instance + Grid module => both rows slide together.
   */
  (function () {
    var INSTANCES = new WeakMap();

    function toBool(value) {
      return value === 'true';
    }

    function buildSwiper(root) {
      if (INSTANCES.has(root)) return;

      var el = root.querySelector('[data-popdept-swiper]');
      if (!el) return;

      var d = root.dataset;
      /* parseFloat, not parseInt — mobile columns may be fractional (e.g. 2.5)
         so the next card peeks in from the right edge. */
      var colsDesktop = parseFloat(d.colsDesktop) || 4;
      var colsTablet = parseFloat(d.colsTablet) || 3;
      var colsMobile = parseFloat(d.colsMobile) || 2;
      var gap = parseInt(d.spaceBetween, 10);
      if (isNaN(gap)) gap = 20;

      var options = {
        modules: undefined, // swiper-bundle registers all modules
        slidesPerView: colsMobile,
        spaceBetween: gap,
        speed: parseInt(d.speed, 10) || 600,
        loop: toBool(d.loop),
        watchOverflow: true,
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous departments',
          nextSlideMessage: 'Next departments'
        },
        keyboard: { enabled: true, onlyInViewport: true },
        grid: { rows: 2, fill: 'row' },
        navigation: {
          prevEl: root.querySelector('[data-popdept-prev]'),
          nextEl: root.querySelector('[data-popdept-next]')
        },
        breakpoints: {
          320: { spaceBetween: 13, slidesPerView: colsMobile, grid: { rows: 2, fill: 'row' } },
          768: { spaceBetween: 13, slidesPerView: colsTablet, grid: { rows: 2, fill: 'row' } },
          1024: { slidesPerView: colsDesktop, grid: { rows: 2, fill: 'row' } }
        }
      };

      if (toBool(d.autoplay)) {
        options.autoplay = {
          delay: parseInt(d.autoplayDelay, 10) || 5000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false
        };
      }

      INSTANCES.set(root, new Swiper(el, options));
    }

    function destroySwiper(root) {
      var instance = INSTANCES.get(root);
      if (instance) {
        instance.destroy(true, true);
        INSTANCES.delete(root);
      }
    }

    /* Swiper is loaded with `defer`, so wait for it before initialising. */
    function whenSwiperReady(callback, attempt) {
      attempt = attempt || 0;
      if (typeof window.Swiper === 'function') return callback();
      if (attempt > 100) return; // ~5s, then give up quietly
      window.setTimeout(function () {
        whenSwiperReady(callback, attempt + 1);
      }, 50);
    }

    /* Draws the heading scribble once the heading scrolls into view. */
    function observeHeadings(container) {
      var headings = container.querySelectorAll('.popdept__heading--animate');
      if (!headings.length) return;

      if (!('IntersectionObserver' in window)) {
        headings.forEach(function (heading) {
          heading.classList.add('popdept--in-view');
        });
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('popdept--in-view');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -15% 0px', threshold: 0.25 }
      );

      headings.forEach(function (heading) {
        observer.observe(heading);
      });
    }

    function initAll(scope) {
      var container = scope || document;

      observeHeadings(container);

      var roots = container.querySelectorAll('[data-popdept][data-slider="true"]');
      if (!roots.length) return;
      whenSwiperReady(function () {
        roots.forEach(buildSwiper);
      });
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    }

    /* Theme editor lifecycle */
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('[data-popdept]');
      if (root) destroySwiper(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
